import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Popconfirm, message } from 'antd';
import apiCall from 'apps/investcore/apiCalls/stock-fundamentals';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

const SyncNowButton = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: () => apiCall.sync.queryFn(undefined),
    onSuccess: () => {
      message.success(
        'Sync queued. It reads ~2000 files and can take a few minutes -- refresh this list once it has had time to finish.'
      );
      queryClient.invalidateQueries({ queryKey: [apiCall.list.queryKey] });
    },
    onError: (err: any) => {
      message.error(err?.message || 'Failed to queue sync');
    },
  });

  return (
    <Popconfirm
      title="Sync all stock fundamentals now?"
      description="Reads every symbol from GCS again -- can take a few minutes."
      onConfirm={() => mutate()}
      okText="Sync"
    >
      <Button type="primary" loading={isPending}>
        Sync now
      </Button>
    </Popconfirm>
  );
};

export const StockFundamentalListPage = () => (
  <ListPage
    title="Stock Fundamentals"
    description="Synced daily from bctc_snowflake (BCTC, valuation, DCF, snowflake score) -- one row per symbol."
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => <DynamicFilterForm fields={filterConfig} />}
    renderRightHeader={() => <SyncNowButton />}
  />
);

export const StockFundamentalDetailPage = props => (
  <DetailPage
    title="Stock Fundamental"
    apiCall={apiCall}
    listUrl={`/admin/stock-fundamentals`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);
